import { GET_CITY_STATE } from "../actionTypes";

export function fetchCityState(data, callback) {
  return {
    type: GET_CITY_STATE,
    data,
    callback
  };
}
